<template>
  <div class="navtab">
    <div
      class="item"
      v-for="(item, index) in getCurrentNavTabs.tabs"
      :key="index"
    >
      <div
        class="router"
        :class="{ activeRouter: item.key === active.key }"
        @click="redirectTo(item)"
      >
        {{ item.label }}
        <div :class="{ bottomdiv: item.key === active.key }"></div>
      </div>
    </div>
    <div class="note" v-if="showNote">
      {{ $t('note') }} <BaseIcon name="upDownArrow" />
      {{ $t('dataComparisionNote') }}
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import {
  CAPABILITY_CLOUD,
  CAPABILITY_DATABASE,
  CAPABILITY_MQ,
} from '../../utils/constants';
import { DatabaseTypes } from '@/components/Database/database.types.js';
import { getMQNavTabs } from '@/utils/templates/mq.template';
import { getDBMNavTabs } from '@/utils/templates/database.template';
import { getGkeNavTabs } from '@/utils/templates/cloud.template';

export default {
  name: 'NavTabDynamic',
  props: {
    active: {},
    data: { type: Array, default: () => [] },
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    // a computed getter
    ...mapState('databaseState/databaseCommonState', ['currentDatabaseType']),
    ...mapState('globalState/app', ['currentCapability']),
    ...mapState('globalState', ['app', 'user', 'settings']),
    ...mapGetters('mqState/mqCommonState', ['getCurrentMQType']),
    getCurrentNavTabs() {
      let items = {};
      switch (this.currentCapability) {
        case CAPABILITY_CLOUD:
          items.tabs = getGkeNavTabs();
          break;
        case CAPABILITY_DATABASE:
          items = getDBMNavTabs()?.find(
            (item) => item.activeTab == this.currentDatabaseType.key,
          );
          break;
        case CAPABILITY_MQ:
          items = getMQNavTabs()?.find(
            (item) => item.activeTab === this.getCurrentMQType.key,
          );
          break;
      }
      return items;
    },
    showNote() {
      return (
        this.currentCapability === CAPABILITY_DATABASE &&
        (this.currentDatabaseType.key === DatabaseTypes.ms ||
          this.currentDatabaseType.key === DatabaseTypes.mg)
      );
    },
  },
  methods: {
    ...mapActions('apmState/apmCommonState', ['getServiceLanguage']),
    redirectTo(option) {
      this.$emit('redirectInput', option);
    },
    mounted() {},
  },
};
</script>

<style lang="scss" scoped>
.navtab {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: transparent;
  height: 2.7188em;
  border-bottom: 0.25em solid $line-separator;
  border-radius: 0.125em;
  margin-top: 1em;
}

.note {
  margin-left: auto;
}

.item {
  height: 100%;
  width: auto;
  border-radius: 0.125em;
  text-align: left;
  text-decoration: none;
  display: flex;
  flex-direction: row;
}
.router {
  text-decoration: none;
  color: $font-primary;
  width: 14.313em;
  height: 2.5em;
  width: auto;
  border-radius: 2px;
  margin-right: 2.5em;
  text-align: left;
  line-height: 1.5625em;
  font-size: 1.25em;
}
.activeRouter {
  cursor: pointer;
  color: $color-brand-accent !important;
  font-family: $semi-bold;
}
.router:hover {
  color: $color-brand-accent;
}
@media only screen and (max-width: 1500px) {
  .router {
    height: 1.9375em;
  }
}
.bottomdiv {
  background-color: $color-brand-accent;
  align-content: center;
  border-radius: 0.125em;
  height: 0.5em;
  margin-top: 0.2em;
  @include dropshadow-effect;
  transition: opacity 3s ease-in-out;
  -webkit-transition: opacity 3s ease-in-out;
  -moz-transition: opacity 3s ease-in-out;
  -ms-transition: opacity 3s ease-in-out;
  -o-transition: opacity 3s ease-in-out;
}
</style>
